import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import { ToggleSection } from '@ynap/toggle'
import Skeleton from '@ynap/skeleton'

const bem = new BEMHelper('OrderTracking')
const timelineItemBem = new BEMHelper('TimelineItem')

const NUM_STEPS = 5

const VerticalTimelineSkeleton: React.FC = () => {
    return (
        <ul className={bem('timelineWrapper')}>
            {new Array(NUM_STEPS).fill(0).map((_, index) => (
                <ToggleSection
                    className={timelineItemBem('', 'skeleton')}
                    title={<Skeleton className={bem('skeleton-timeline')} />}
                    type="heading"
                    key={index}
                    headerClassName={timelineItemBem('header')}
                />
            ))}
        </ul>
    )
}

export default VerticalTimelineSkeleton
